/**
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary[]} userGames
 * @param {string|undefined} NestiFyzId
 * @returns {import("@seabrookstudios/pitch2table-core").GameSummary|undefined}
 */
export const findGameByNestiFyzId = (userGames, NestiFyzId) => {
  if (!NestiFyzId) {
    return undefined;
  }

  return userGames.find((game) => game.internalId === NestiFyzId);
};
